import axios from 'axios';
import { LOGIN_ERROR } from '../_store/auth/actionTypes';
import store from '../_store';

const apiUrl = process.env.VUE_APP_BACK_END_API;

function buildUrlLogin(url) {
  return apiUrl + url;
}
function buildUrl(url) {
  return apiUrl + 'api/ws-admin/' + url;
}

// FIXME: Duplicated in _store/auth/actions.js
const COOKIE_TOKEN = 'token';

function readCookie() {
  let value = document.cookie.match('(^|;)?' + COOKIE_TOKEN + '=([^;]*)(;|$)');
  return value ? unescape(value[2]) : null;
}
//

export default {
  postforlogin(path, payload) {
    const url = buildUrlLogin(path);
    return axios
      .post(url, payload)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  post(path, payload) {
    if (readCookie()) {
      axios.defaults.headers.common.Authorization = 'token ' + readCookie();

      const url = buildUrl(path);
      return axios
        .post(url, payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          if ([401, 403].includes(error.response.status)) {
            store.dispatch(LOGIN_ERROR);
          }
          return error;
        });
    }
  },
  get(path) {
    if (readCookie()) {
      axios.defaults.headers.common.Authorization = 'token ' + readCookie();

      const url = buildUrl(path);
      return axios
        .get(url)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          if ([401, 403].includes(error.response.status)) {
            console.log('logout', LOGIN_ERROR);
            store.dispatch(LOGIN_ERROR);
          }
          return error;
        });
    }
  },
  patch(path, payload) {
    if (readCookie()) {
      axios.defaults.headers.common.Authorization = 'token ' + readCookie();

      const url = buildUrl(path);
      return axios
        .patch(url, payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          if ([401, 403].includes(error.response.status)) {
            store.dispatch(LOGIN_ERROR);
          }
          return error;
        });
    }
  },
  put(path, payload) {
    if (readCookie()) {
      axios.defaults.headers.common.Authorization = 'token ' + readCookie();

      const url = buildUrl(path);
      return axios
        .put(url, payload)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          if ([401, 403].includes(error.response.status)) {
            store.dispatch(LOGIN_ERROR);
          }
          return error;
        });
    }
  },
  delete(path) {
    if (readCookie()) {
      axios.defaults.headers.common.Authorization = 'token ' + readCookie();

      const url = buildUrl(path);
      return axios
        .delete(url)
        .then((response) => {
          return response;
        })
        .catch((error) => {
          if ([401, 403].includes(error.response.status)) {
            store.dispatch(LOGIN_ERROR);
          }
          return error;
        });
    }
  }
};
